import { memo } from 'react'
import { Outlet } from "react-router"
import MMPNavbar from "../components/mmp-navbar"
import MMPFooter from "../components/mmp-footer"

const Root = memo(function Root() {
    return (
        <>
            <MMPNavbar />
            <main id="detail">
                <Outlet />
            </main>
            <MMPFooter />
        </>
    )
})

export default Root